/*!

=========================================================
* Paper Dashboard Angular - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-angular
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-angular/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {Amplify,  Auth} from 'aws-amplify';
import awsconfig from './aws-exports';
import "zone.js"

Amplify.configure(awsconfig);

const oauth = {
  domain: environment.domainName,
  scope: environment.scope,
  redirectSignIn: environment.redirectSignIn,
  redirectSignOut: environment.redirectSignOut,
  responseType: environment.responseType
}

Auth.configure({
  oauth: oauth
});


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
